$(function()
{
	let babyIndex = 1; // Track how many babies have been added
	if(typeof bKioskmode !== "undefined" && bKioskmode === true)
	{
		setTimeout(pollIdleTimer,60000);

		if(typeof sWishlistRoute !== "undefined" && sWishlistRoute === "success")
		{
			pollWishlistBasketSales(20)
		}
	}
	if(typeof bPollForFinalize !== "undefined" && bPollForFinalize === true)
	{
		pollForFinalize(20);
	}

	if ($(".updateWishlistMode").length > 0) {

		let rawPrefill = $(".updateWishlistMode").data("prefilled");
		let oDataPrefill = JSON.parse(JSON.stringify(rawPrefill));
		if (oDataPrefill.length) {
			for (var i = 0; i < oDataPrefill.length; i++) {
				if (i === 0) {
					$(".updateWishlistMode").find('#wishlistName').val(oDataPrefill[i].name);
					$(".updateWishlistMode").find('#baby_' + (babyIndex-1) + '_name').val(oDataPrefill[i].name);
					$(".updateWishlistMode").find('#baby_' + (babyIndex-1) + '_gender').val(oDataPrefill[i].gender ? oDataPrefill[i].gender.toLowerCase() : "x");
					babyIndex++; // Increment for the next baby
				} else {
					let newBabyIndex = babyIndex-1;

					var sRemoveBabyFormButton = $("input[name='removeBabyTranslation']").val(); // For some reason the variable helper is not picking this up so I am using a hidden input field
					// Clone the first baby form and remove any filled values
					let newBabyForm = $(".babyForm:first").clone();
					newBabyForm.attr("data-index", newBabyIndex); // Update data-index

					// Update input field names and IDs
					newBabyForm.find("input, select").each(function() {
						let oldId = $(this).attr("id");
						let oldName = $(this).attr("name");

						// Adjust new ID and name by replacing the old index with the new index
						if (oldId) {
							let newId = oldId.replace(/\d+/, newBabyIndex);
							$(this).attr("id", newId);
						}
						if (oldName) {
							let newName = oldName.replace(/\d+/, newBabyIndex);
							$(this).attr("name", newName);
						}

						// Clear values
						$(this).val("");
					});

					newBabyForm.find(".removeBaby").remove();

					let removeButton = $('<button type="button" class="removeBaby">' + sRemoveBabyFormButton + '</button>');
					newBabyForm.append(removeButton);

					newBabyForm.find('#baby_' + (babyIndex-1) + '_name').val(oDataPrefill[i].name);
					newBabyForm.find('#baby_' + (babyIndex-1) + '_gender').val(oDataPrefill[i].gender ? oDataPrefill[i].gender : "x");
					// Append the new baby form
					$("#babyFormContainer").append(newBabyForm);

					//Toggle required/not required baby name according to checkbox
					$('#babyFormContainer #baby_' + (babyIndex-1) + '_unknownName').on("change", function () {
						if ($(this).is(':checked')) {
							$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').removeAttr('required');
							$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').prop("disabled", true);
							$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').val('');
						} else {
							$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').attr('required', true);
							$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').prop("disabled", false);
						}
					});
					babyIndex++; // Increment for the next baby
				}

			}
		} else {
			$(".updateWishlistMode").find('#wishlistName').val(oDataPrefill.owners[0].name);
		}

	}

	$(el("mainContainer")).on("change",".editProduct .updateValue", function()
	{
		updateLine($(this));
	});

	$(el("mainContainer")).on("click",".editProduct .updateFavourite", function()
	{
		var oInput = $(this).parents(".addFavourite").find(".updateValue[data-key='favourite']");

		var sValue = (oInput.val() == "false") ? "true" : "false";
		if (sValue=="true"){
			$(this).removeClass("far").addClass("fas");
		}
		else{
			$(this).removeClass("fas").addClass("far");

		}

		oInput.val(sValue).trigger("change");
	});

	$(el("mainContainer")).on("click",".editProduct .updateReserved", function()
	{
		var sSkuIds = $(this).parents(".editProduct").data("skuid");
		promptReserveModal($(this), sSkuIds);
	});

	$(el("mainContainer")).on("click",".editProductsReserveModal .reserveBtn", function()
	{
		reserveLines($(this));
	});

	$(el("mainContainer")).on("change",".editProduct .selectLine", function()
	{
		$("#selectedCount").text($(".editProduct .selectLine:checked").length);
	});

	$(el("mainContainer")).on("change",".collectProducts .selectLine", function()
	{
		collectProduct($(this));
	});

	$(el("mainContainer")).on("change",".collectProducts .selectAllLines", function()
	{
		addSkusToWishlistBasket($(this));
	});

	$(el("mainContainer")).on("change",".editProductsReserveModal .selectLine", function()
	{
		setReserveConfirmState();
	});


	$(el('mainContainer')).on('change','.editProducts #selectAll',function()
	{
		var oCheckboxes = $('input[name="selectedLines"]');
		oCheckboxes.prop('checked', $(this).prop('checked')).trigger('change');
	});
	$(el('mainContainer')).on('change','.collectProducts #selectAll',function()
	{
		var oCheckboxes = $('input[name="selectedLines"]');
		oCheckboxes.prop('checked', $(this).prop('checked')).trigger('change');
	});

	$(el('mainContainer')).on('submit','.editProducts #frmEditProductsBulkUpdate',function(e)
	{
		e.preventDefault();

		var sKey = $("#bulkKey").val();
		var dataBit = $("#bulkKey option:selected").data("bit");

		if(sKey !== "")
		{
			if(sKey == 'reserved')
			{
				var sSkuIds = getSelectedSkus($(".editProduct"));
				if(sSkuIds !== "")
				{
					promptReserveModal($(this).find(".btn"), sSkuIds);
				}
				else
				{
					showAlert('error', 'You must select at least one product to update.', false, 3000);
				}
			}
			else
			{
				var bBitValue = dataBit !== undefined ? parseInt(dataBit) : 1;
				bulkUpdateLines(sKey, bBitValue);
			}
		}
	});

	$(el('mainContainer')).on('change','.editProducts .inputQty',function()
	{
		updateQuantity($(this));
	});

	$(el('mainContainer')).on('click', '.deleteProduct', function()
	{
		askDeleteLine($(this));
	});

	$(el('mainContainer')).on('click', '#deleteLine', function()
	{
		deleteLine($(this));
	});

	$(el('mainContainer')).on('click', '.deleteGiftVouchers', function()
	{
		askDeleteGiftVouchers();
	});

	$(el('mainContainer')).on('click', '#deleteGiftVouchers', function()
	{
		deleteGiftVouchers($(this));
	});

	$(el('mainContainer')).on('click', '#selectAllFromAllPages', function()
	{
		selectAllFromAllPages($(this));
	});

	$(el('mainContainer')).on('submit', '#searchWishlistFrm', function(e)
	{
		e.preventDefault();

		searchWishlist($(this));
	});

	$(el('mainContainer')).on('submit', '#scanWishlistFrm', function(e)
	{
		e.preventDefault();

		var sUrl = $(el("inputBarcode")).val();
		if(sUrl)
		{
			window.location.href = sUrl;
		}
	});

	$(el('mainContainer')).on('click','#searchResultsModal.enabled .listItem', function(e)
	{
		e.preventDefault();

		selectSearchResult($(this));
		return false;
	});

	 $(el('mainContainer')).on('click','#searchResultsModal .loaderWrapper', function()
	{
		return false;
	});

	$(el('mainContainer')).on('keyup change','#wishlistName', function()
	{
		$("#baby_0_name").val($(this).val());
	});

	$(el('mainContainer')).on('change','#hidden', function()
	{
		$("#baby_0_hidden").prop("checked", $(this).is(":checked"));
	});

	$(el('mainContainer')).on('click', '.reAddDeletedProduct', function()
	{
		reAddDeletedProduct($(this));
	});

	$(el('mainContainer')).on('click','.addToWishlistBasket', function()
	{
		addToWishlistBasket($(this));
	});

	$(el('mainContainer')).on('click','.buyProductImage', function()
	{
		var sSkuId = $(this).parents(".buyProduct").data("skuid");
		var oPopup = $('#buyProductDetailImg' + sSkuId);
		oPopup.modal('show');
	});


	$(el('mainContainer')).on('change','.edtCollectMethod', function()
	{
		if($(this).val() !== "")
		{
			validateCollectMethod($(this));
		}
	});

	$(el('mainContainer')).on('click','.collectMethodSubmit', function()
	{
		collectMethodSubmit($(this));
	});

	$(el('mainContainer')).on('click','.editCollectMethodData', function()
	{
		showBasketCollectMethodModal($(this).data("method"));
	});

	$(el('mainContainer')).on('click','.basketSubmit', function()
	{
		basketSubmit($(this));
	});

	$(el('mainContainer')).on('click','.deleteFromWishlistBasket', function()
	{
		deleteFromWishlistBasket($(this));
	});
	$(el('mainContainer')).on('click','.copyToClipboard', function()
	{
		$(this).addClass("copied").delay(3000).queue(function(next){
			$(this).removeClass("copied");
			next();
		});
		navigator.clipboard.writeText($(this).parents(".copyClipboard").find("input[type='text']").val());
	});
	$(el('mainContainer')).on('click','.downloadQrCode', function(e)
	{
		e.preventDefault();

		downloadQrCode($("#createQrCodeResult img"));
	});
	$(el('mainContainer')).on('click','.downloadLoginQrCode', function(e)
	{
		e.preventDefault();

		downloadQrCode($("#createLoginQrCodeResult img"));
	});
	$(el('mainContainer')).on('change','.inputAmount, .inputQty', function()
	{
		var sMax   = Number($(this).attr("max"));
		var sValue = Number($(this).val());

		if(isNaN(sValue) || sValue > sMax)
		{
			$(this).val(sMax);
		}
	});

	$(el('mainContainer')).on('submit','.collectProducts .collectMethodForm', function(e)
	{
		e.preventDefault();

		var oFrm = $(this);
		var oBtn = oFrm.find('button[type="submit"]');
		oBtn.prop("disabled", true).addClass("loading");

		var bValid = validateForm(oFrm);
		if(bValid)
		{
			var sCollectMethodCode = oFrm.data("collectMethodCode");
			var sSkuIds = getSelectedSkus($(".collectProductsList .collectProduct"));

			if(sSkuIds !== "")
			{
				var sParams = getValues(oFrm);
				sParams += '&id=' + sWishlistId + '&skuIds=' + sSkuIds + '&collectMethodCode=' + sCollectMethodCode + '&wishlistCustomerId=' + sWishlistCustomerId;

				var oCall   = callAjax("collectProducts", sParams, "post", "/index.cfm/wishlist/ajax/collectProducts");
				oCall.success(function(oData)
				{
					if(oData.errorType === '')
					{
						window.location = oData.redirectUrl;
					}
					else
					{
						showAlert('error', oData.errorMessage, false, 3000);
					}
					oBtn.prop("disabled", false).removeClass("loading");
				});
			}
			else
			{
				oBtn.prop("disabled", false).removeClass("loading");
			}
		}
	});

	$(el('mainContainer')).on('submit','.finalize .collectMethodForm', function(e)
	{
		e.preventDefault();

		var oFrm = $(this);
		var oBtn = oFrm.find('button[type="submit"]');
		oBtn.prop("disabled", true);

		var bValid = validateForm(oFrm);
		if(bValid)
		{
			var sCollectMethodCode = oFrm.data("collectMethodCode");
			var sSkuIds = $(".finalize").find(".basketProduct").map(function() {
				return $(this).data("skuid");
			}).get().join(',');

			var sParams = getValues(oFrm);
			sParams += '&id=' + sWishlistId + '&basketId=' + sBasketId + '&skuIds=' + sSkuIds + '&collectMethodCode=' + sCollectMethodCode + '&wishlistCustomerId=' + sWishlistCustomerId;

			var oCall   = callAjax("finalizeOpenLines", sParams, "post", "/index.cfm/wishlist/ajax/finalizeopenlines");
			oCall.success(function(oData)
			{
				if(oData.errorMessage === '')
				{
					window.location = "payment";
				}
				else
				{
					showAlert('error', oData.errorMessage, false, 3000);
				}
				oBtn.prop("disabled", false);
			});
		} else {
			oBtn.prop("disabled", false);
		}
	});

	$(el('mainContainer')).on('click','.finalizeBtn', function()
	{
		finalizeWishlist($(this));
	});
	// data-toggle="modal" cllick handler for wishlist product donor



	$(el('mainContainer')).on("click", ".collectProductDonor button[data-toggle='modal'], .editProducts button[data-toggle='modal']", function ()
	{
		var aDonors = $(this).data("donors");

		var sHtml = "<div class='donorList'>";
		for (var i = 0; i < aDonors.length; i++) {
			var sAmount = aDonors[i].amount || "";
			var sDateBought = aDonors[i].dateBought || "";
			var sName = aDonors[i].name || "Unknown";
			var sMessage = aDonors[i].message || "";

			sHtml += "<div class='donorItem'>";
			sHtml += "<div class='donorDateBought'>" + sDateBought + "</div>";
			sHtml += "<div class='donorName'><strong>" + sName + ":</strong> " + sAmount + "</div>";
			if (sMessage) {
				sHtml += "<div class='donorMessage'>" + sMessage + "</div>";
			}
			sHtml += "</div>";
		}
		sHtml += "</div>";

		$("#donorModal .modal-body").html(sHtml);
	});

	$(el('mainContainer')).on("change", ".basketCcShops", function() {
		//if selected option has data-wishlist-shop="false", show a warning message
		var oSelectedOption = $(this).find("option:selected");
		if(oSelectedOption.data("wishlist-shop") === false)
		{
			$(".ccShopWarning").show();
		}
		else
		{
			$(".ccShopWarning").hide();
		}
	});

	$(el('mainContainer')).on("click", "#edtNeedInvoice", function(e)
	{
		if ($(this).is(":checked"))
		{
			$(".basketInvoiceFormModal").modal("show");
		}
	});

	$(el('mainContainer')).on("click", ".invoiceFormSubmit", function(e)
	{
		var oBtn = $(this);
		oBtn.prop("disabled", true);

		var bValid = validateForm($(".basketInvoiceFormModal"));

		if (bValid)
		{
			var sParams = getValues($(".basketInvoiceFormModal"));
			sParams += '&id=' + sWishlistId + "&basketId=" + sBasketId

			var oCall   = callAjax("invoiceinfo", sParams, "post", "/index.cfm/wishlist/ajax/invoiceinfo");
			oCall.success(function(oData)
			{
				if(oData.errorMessage === '')
				{
					$(".basketInvoiceFormModal").modal("hide");
					$("#edtNeedInvoice").prop("checked", true);
				}
				else
				{
					showAlert('error', oData.errorMessage, false, 3000);
					$("#edtNeedInvoice").prop("checked", false);
				}

				oBtn.prop("disabled", false);
			});
		}
		else
		{
			$("#edtNeedInvoice").prop("checked", false);
			oBtn.prop("disabled", false);
		}
	});

	$(el('mainContainer')).on("click", ".showGifted", function(e)
	{
		$(".iFacet[data-filter='properties'][data-value='GIFTED']").trigger("change");
	});

	$(el('mainContainer')).on("click", ".shareWishlistLoginContainer .accordion-toggle", function(e)
	{
		if ($(".shareWishlistLoginInner").children().length === 0)
		{
			askShareWishlistLogin();
		}
	});

	$(el('mainContainer')).on("click", "#shareWishlistLogin", function(e)
	{
		shareWishlistLogin($(this));
	});

	$("#wishlistForm").on("click", ".submitWishlist", function(event) {
		event.preventDefault(); // Prevent default form submission
		$(this).prop("disabled", true);
		var oFrm = $(el("wishlistForm"));
		var bValid = validateWishlistForm(oFrm);

		if (bValid) {
			submitWishlistForm(getValues(oFrm),$(this),false);
		} else {
			$(this).prop("disabled", false);
		}
	});

	$("#wishlistForm").on("click", ".updateWishlist", function(event) {
		event.preventDefault(); // Prevent default form submission
		$(this).prop("disabled", true);
		var oFrm = $(el("wishlistForm"));
		var bValid = validateWishlistForm(oFrm);

		if (bValid) {
			submitWishlistForm(getValues(oFrm),$(this),true);
		} else {
			$(this).prop("disabled", false);
		}
	});

	//Wishlist form - toggle required/not required wishlist name according to checkbox
	  $('#wishlistForm .info #hidden').on("change", function () {
		if ($(this).is(':checked')) {
			$('.formSection.info #wishlistName').removeAttr('required');
			$('.formSection.info #wishlistName').val('');
			$('.formSection.info #wishlistName').prop("readonly", true);
			if ($("#baby_0_name").length) {
				$("#baby_0_name").val('');
				$("#baby_0_name").attr('required', false);
			}

		} else {
			$('.formSection.info #wishlistName').attr('required', true);
			$('.formSection.info #wishlistName').prop("readonly", false);
			if ($("#baby_0_name").length) {
				$("#baby_0_name").attr('required', true);
			}
		}
	  });

	  if ($('#babyFormContainer').length === 0) {
		$('.wishlistWrapper .formSection.info .control-group[data-name="eventDate"]').css("position", "relative");
	  }

	$("#wishlistForm #contactDropdown").change(function() {
		let selectedOption = $(this).find(":selected");
		let contactId = selectedOption.val();
		let contactName = selectedOption.text();
		let selectedContacts = [];

		if (contactId) {
			// Add contact to the selected table
			$("#selectedContactsTable").append(`
				<tr data-id="${contactId}">
					<input type="hidden" class="inputContact" required name="inputContact" value="${contactId}">
					<td>${contactName}</td>
					<td><button class="removeContact"><i class="fa fa-remove"></i></button></td>
				</tr>
			`);

			// Store selected contact ID
			selectedContacts.push(contactId);

			// Update hidden input
			$("#selectedContacts").val(selectedContacts.join(","));

			// Remove from dropdown
			selectedOption.remove();
			$(".contactsTables .inlineAlert").remove(); // Reset dropdown
		}
	});

	// When a contact is removed from the table
	$("#wishlistForm").on("click", ".removeContact", function() {
		let row = $(this).closest("tr");
		let contactId = row.data("id");
		let contactName = row.find("td:first").text();

		// Remove from selectedContacts array
		selectedContacts = $.grep(selectedContacts, function(id) {
			return id != contactId; // Remove the ID that matches
		});

		// Update hidden input
		$("#selectedContacts").val(selectedContacts.join(","));

		// Re-add contact to the dropdown
		$("#contactDropdown").append(`<option value="${contactId}">${contactName}</option>`);

		// Remove from table
		row.remove();
	});

	$("#wishlistForm").on("click", "#addBaby", function() {
		let newBabyIndex = babyIndex;

		var sRemoveBabyFormButton = $("input[name='removeBabyTranslation']").val(); // For some reason the variable helper is not picking this up so I am using a hidden input field
		// Clone the first baby form and remove any filled values
		let newBabyForm = $(".babyForm:first").clone();
		newBabyForm.attr("data-index", newBabyIndex); // Update data-index

		// Update input field names and IDs
		newBabyForm.find("input, select").each(function() {
			let oldId = $(this).attr("id");
			let oldName = $(this).attr("name");

			// Adjust new ID and name by replacing the old index with the new index
			if (oldId) {
				let newId = oldId.replace(/\d+/, newBabyIndex);
				$(this).attr("id", newId);
			}
			if (oldName) {
				let newName = oldName.replace(/\d+/, newBabyIndex);
				$(this).attr("name", newName);
			}

			// Clear values
			$(this).val("");
		});

		newBabyForm.find(".removeBaby").remove();

		let removeButton = $('<button type="button" class="removeBaby">' + sRemoveBabyFormButton + '</button>');
		newBabyForm.append(removeButton);

		// Append the new baby form
		$("#babyFormContainer").append(newBabyForm);

		//Toggle required/not required baby name according to checkbox
		$('#babyFormContainer #baby_' + (babyIndex) + '_unknownName').on("change", function () {
			if ($(this).is(':checked')) {
				$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').removeAttr('required');
				$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').prop("disabled", true);
				$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').val('');
			} else {
				$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').attr('required', true);
				$('#babyFormContainer #baby_' + (babyIndex-1) + '_name').prop("disabled", false);
			}
		});
		babyIndex++; // Increment for the next baby
	});

	// Remove a baby form
	$("#wishlistForm").on("click", ".removeBaby", function() {
		$(this).closest(".babyForm").remove();
		updateRemoveButtonVisibility($(".babyForm .removeBaby")); // Ensure at least one remains
	});

	if($('.shareWishlistQRCode').length) {
		document.getElementById("createQrCodeResult")
		createWishlistQrCode($("input[name='inputShareUrl']").val(), document.getElementById("createQrCodeResult"));
	}

	updateRemoveButtonVisibility($(".babyForm .removeBaby"));
	initDropzone();
	init();
});

// Update selected count when checkboxes change in either bought or not bought lists
function updateSelectedCount() {
	var count = $("#collectProductsListSelected .selectLine:checked").length
		$("#selectedCollectCount").text(count);
}

function collectProduct(oInput)
{
	$(el('loader')).toggleClass('hidden');
	$(".collectProducts .selectLine").prop("disabled", true);

	var oProduct = oInput.parents(".collectProduct");

	var sCta    = (oInput.is(":checked")) ? "add": "delete";
	var sSkuId  = oProduct.data("skuid");
	var bBought = oProduct.data("bought");
	var sType   = oProduct.find(".inputType").val();
	var sValue  = oProduct.find(".inputValue").val();

	var sParams = '&cta=' + sCta + '&skuId=' + sSkuId + '&id=' + sWishlistId + '&type=' + sType + '&value=' + sValue + '&bought=' + bBought;
	var oCall   = callAjax("collectproduct", sParams, "post", "/index.cfm/wishlist/ajax/collectproduct");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			setCollectProductsButtonState();

			(bKioskmode) ? $("#mainContainer #viewOnlyWrapper > .wishlistWrapper").replaceWith(oData.html) : $("#mainContainer > .wishlistWrapper").replaceWith(oData.html);
			ciResponsive.process();
		}
		else
		{
			// reset checkbox to previous state
			$(el('loader')).toggleClass('hidden');
			$(".collectProducts .selectLine").prop("disabled", false);
			oInput.prop("checked", !oInput.is(":checked"));

			showAlert('error', oData.errorMessage, false, 3000);
		}
		updateSelectedCount();
	});
}

function createWishlistQrCode(sWishlistShareUrl, oResultContainer)
{
	// create qr code
	var sParams = '&url=' + sWishlistShareUrl;
	var oCall = callAjax("createqrcode", sParams, "POST", "/index.cfm/ajax/createqrcode");
	// process result
	oCall.success(function (oData)
	{
		new QRCode(oResultContainer, {
			text: oData.qrCodeUrl,
			width: 250,
			height: 250
		});
	});
}

function downloadQrCode(oImg) {
	var aUrl = window.location.href.split("/");
	var sFileName = aUrl[aUrl.length - 1].replace(/[\W_]+/g,"-");
	var sSrc = oImg.attr("src");
	var oAnchor = document.createElement("a");
	oAnchor.href = sSrc;
	oAnchor.download = "qrcode-" + sFileName + ".png";
	oAnchor.click();
}

function addSkusToWishlistBasket(oInput)
{
	oInput.prop("disabled", true);

	$(el('loader')).toggleClass('hidden');

	var oPayload = {};
	oPayload.skus = [];
	oPayload.id = sWishlistId;
	oPayload.cta = (oInput.is(":checked")) ? "add": "delete";

	$(".collapse .collectProduct").each(function() {
		var type = $(this).find(".inputType").val();
		var value = $(this).find(".inputValue").val();
		var oRecord = {
			"skuId": $(this).data('skuid').toString(),
			[type]: parseFloat(value)
		}
		oPayload.skus.push(oRecord);
	});

	var oCall   = callAjax("bulkUpdateBasket", oPayload, "post", "/index.cfm/wishlist/ajax/bulkupdatebasket");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			setCollectProductsButtonState();

			(bKioskmode) ? $("#mainContainer #viewOnlyWrapper > .wishlistWrapper").replaceWith(oData.html) : $("#mainContainer > .wishlistWrapper").replaceWith(oData.html);
			ciResponsive.process();
		}
		else
		{
			// reset checkbox to previous state
			$(el('loader')).toggleClass('hidden');
			oInput.prop("checked", !oInput.is(":checked"));
			oInput.prop("disabled", true);

			showAlert('error', oData.errorMessage, false, 3000);
		}
		updateSelectedCount();
	});
}

function addToWishlistBasket(oBtn)
{
	$(el('loader')).toggleClass('hidden');
	$(".addToWishlistBasket").prop("disabled", true);

	var oProduct = oBtn.parents(".buyProduct");
	var sSkuId   = oProduct.data("skuid");
	var sType    = oBtn.data("type");
	var sColour  = oBtn.data("colour");
	var sSize    = oBtn.data("size");
	var sPicture = oBtn.data("picture");

	if(sType === "quantity")
	{
		var sValue = oProduct.find(".inputQty").val();
	}
	else if(sType === "amount")
	{
		var sValue = oProduct.find(".inputAmount").val();
	}

	var sParams = '&skuId=' + sSkuId + '&type=' + sType + '&value=' + sValue + '&id=' + sWishlistId + '&colour=' + sColour + '&size=' + sSize + '&picture=' + sPicture;

	var oCall   = callAjax("addtowishlistbasket", sParams, "post", "/index.cfm/wishlist/ajax/addtowishlistbasket");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			$(('.outerContainer')).replaceWith(oData.html);
			$(('.buyProductsBasketSmall')).replaceWith(oData.htmlBasketSmall);
			addToWishlistBasketPopup(oData);
			ciResponsive.process();
		}
		else
		{
			$(el('loader')).toggleClass('hidden');
			$(".addToWishlistBasket").prop("disabled", false);

			showAlert('error', oData.errorMessage, false, 3000);
		}
	});
}

function addToWishlistBasketPopup(oData)
{
	// show modal
	$("#mainContainer header").append(oData.productAddedDropdown);
	$("#mainContainer header .wishlistProductDropdown").css('animation','pulse 2s 3');
	$("#mainContainer header .wishlistProductDropdown").hide().fadeIn(500).delay(5000).fadeOut(500, function(){
		$(this).remove();
	});

}

function askDeleteLine(oBtn)
{
	var sSkuId = oBtn.parents(".editProduct").data("skuid");

	var oPopup = $('#popupContinue');

	setAction(oPopup, 'deleteLine', {'skuId': sSkuId});
	setPopupHeader(oPopup, sAskRemoveLineTitle, '');
	oPopup.find('.modal-body .content').html(sAskRemoveLineContent);

	oPopup.find('.modal-footer .action').html(sAskRemoveLineConfirm);
	oPopup.find('.modal-footer .cancel').html(sAskRemoveLineCancel);

	oPopup.modal();
}

function askDeleteGiftVouchers(oBtn)
{
	var oPopup = $('#popupContinue');

	setAction(oPopup, 'deleteGiftVouchers');
	setPopupHeader(oPopup, sAskDeleteGiftVouchersTitle, '');

	oPopup.find('.modal-footer .action').html(sConfirm);
	oPopup.find('.modal-footer .cancel').html(sCancel);

	oPopup.modal();
}

function askShareWishlistLogin()
{
	var oPopup = $('#popupContinue');

	setAction(oPopup, 'shareWishlistLogin', {});
	setPopupHeader(oPopup, sAskShareWishlistLogin, '');
	oPopup.find('.modal-footer .action').html(sConfirm);
	oPopup.find('.modal-footer .cancel').html(sCancel);

	oPopup.modal();
}

function basketSubmit(oBtn)
{
	oBtn.prop("disabled", true);

	var bValid = validateForm($(".basketPersonalize"));

	if(bValid)
	{
		var sParams = getValues($(".basketPersonalize"));
		sParams += '&id=' + sWishlistId + "&basketId=" + sBasketId + "&wishlistCustomerId=" + sWishlistCustomerId;

		var oCall   = callAjax("checkout", sParams, "post", "/index.cfm/wishlist/ajax/checkout");
		oCall.success(function(oData)
		{
			if(oData.errorMessage === '')
			{
				window.location = "payment";
			}
			else
			{
				inlineAlert('error', oData.errorMessage, false, oBtn, false, 10000);
			}

			oBtn.prop("disabled", false);
		});
	}
	else
	{
		oBtn.prop("disabled", false);
	}
}

function collectMethodSubmit(oBtn)
{
	oBtn.prop("disabled", true);

	var bValid = validateForm($(".basketCollectMethodModal .modal-body"));

	if(bValid)
	{
		var sCollectMethodCode = oBtn.data("collectMethodCode");

		var sParams = getValues($(".basketCollectMethodModal .modal-body"));
		sParams += '&id=' + sWishlistId + "&basketId=" + sBasketId + "&collectMethodCode=" + sCollectMethodCode;

		updatebasket(sParams, oBtn.data("skuId"), sCollectMethodCode, oBtn.data("showWarning"), oBtn);
	}
	else
	{
		oBtn.prop("disabled", false);
	}
}

function deleteFromWishlistBasket(oBtn)
{
	$(el('loader')).toggleClass('hidden');
	oBtn.prop("disabled", true);

	var sSkuId = oBtn.parents(".basketProduct").data("skuid");

	var sParams = '&id=' + sWishlistId + "&basketId=" + sBasketId + "&skuId=" + sSkuId + "&wishlistRoute=" + sWishlistRoute;
	var oCall = callAjax("deleteFromWishlistBasket", sParams, "post", "/index.cfm/wishlist/ajax/deleteFromWishlistBasket");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			(bKioskmode) ? $("#mainContainer #viewOnlyWrapper > .wishlistWrapper").replaceWith(oData.html) : $("#mainContainer > .wishlistWrapper").replaceWith(oData.html);
			ciResponsive.process();
		}
		else
		{
			$(el('loader')).toggleClass('hidden');
			showAlert('error', oData.errorMessage, false, 3000);
		}

		oBtn.prop("disabled", false);
	});
}

function deleteGiftVouchers(oBtn)
{
	oBtn.prop("disabled", true);


	var sParams = '&id=' + sWishlistId + '&basketId=' + sBasketId;
	var oCall   = callAjax("deleteGiftVouchers", sParams, "post", "/index.cfm/wishlist/ajax/deletegiftvouchers");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			$('#popupContinue').modal('hide');

			$(('.outerContainer')).replaceWith(oData.html);
			$("#mainContainer header .wishlistWrapper").replaceWith(oData.headerLinksHtml);
			ciResponsive.process();
		}
		else
		{
			$('#popupContinue').modal('hide');

			showAlert('error', oData.errorMessage, false, 3000);
		}

		oBtn.prop("disabled", false	);
	});
}

function deleteLine(oBtn)
{
	oBtn.prop("disabled", true);

	var sSkuId = oBtn.attr("skuid");

	var sParams = '&skuId=' + sSkuId + '&id=' + sWishlistId;
	var oCall   = callAjax("deleteLine", sParams, "post", "/index.cfm/wishlist/ajax/deleteLine");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			$('#popupContinue').modal('hide');

			$(('.outerContainer')).replaceWith(oData.html);
			$("#mainContainer header .wishlistWrapper").replaceWith(oData.headerLinksHtml);
			ciResponsive.process();
		}
		else
		{
			$('#popupContinue').modal('hide');

			showAlert('error', oData.errorMessage, false, 3000);
		}

		oBtn.prop("disabled", false	);
	});
}

function finalizeWishlist(oBtn)
{
	oBtn
		.css('min-width', oBtn.outerWidth())
		.prop('disabled', true) // disable to prevent double-clicks
		.data('original-text', oBtn.html()) // save current text
		.html('<div class="loader"><i class="fa fa-spinner fa-spin"></i></div>');

	var sParams = "&id=" + sWishlistId;
	var oCall   = callAjax("finalizeWishlist", sParams, "post", "/index.cfm/wishlist/ajax/finalizeWishlist");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			(bKioskmode) ? $("#mainContainer #viewOnlyWrapper > .wishlistWrapper").replaceWith(oData.html) : $("#mainContainer > .wishlistWrapper").replaceWith(oData.html);
		}
		else if(oData.errorType === 'noFinalBasket')
		{
			window.location = oData.redirectUrl;
		}
		else
		{
			inlineAlert('error', oData.errorMessage, false, oBtn, false);
			oBtn
				.prop('disabled', false)
				.html(oBtn.data('original-text'));
		}
	});
}
function getSelectedSkus(oElements)
{
	var aLines = [];
	oElements.each(function() {
		if($(this).find(".selectLine").is(":checked")){
			aLines.push({
				"skuId": $(this).data('skuid').toString()
			});
		}
	});

	return aLines.map(function(line) { return line.skuId; }).join(',');
}

function pollIdleTimer()
{
	var oCall   = callAjax("pollIdleTimer", "", "post", "/index.cfm/wishlist/ajax/pollIdleTimer");
	oCall.success(function(oData)
	{
		if(oData.remainingTime > 0)
		{
			setTimeout(pollIdleTimer, 10000);
		}
		else
		{
			window.location = "/" + sCurrentLanguageCode + "/wishlist/search";
		}
	});
}

function pollForFinalize(iRetries)
{
	var sParams = "&wishlistId=" + sWishlistId + "&idco=" + sIdco;
	var oCall   = callAjax("pollForFinalize", sParams, "post", "/index.cfm/wishlist/ajax/pollForFinalize");
	oCall.success(function(oData)
	{
		if(oData.errorType !== '')
		{
			if(iRetries > 0)
			{
				iRetries--;
				setTimeout(function() {
					pollForFinalize(iRetries);
				}, 1000);
			}
			else
			{
				$("#processingLoader").hide();
			}
		}
		else
		{
			$("#processingLoader").hide();

			(bKioskmode) ? $("#mainContainer #viewOnlyWrapper > .wishlistWrapper").replaceWith(oData.html) : $("#mainContainer > .wishlistWrapper").replaceWith(oData.html);
			ciResponsive.process();
		}
	});
}

function pollWishlistBasketSales(iRetries)
{
	var sParams = "&transactionId=" + sTransactionId;
	var oCall   = callAjax("pollWishlistBasketSales", sParams, "post", "/index.cfm/wishlist/ajax/pollWishlistBasketSales");
	oCall.success(function(oData)
	{
		if(oData.errorType !== '')
		{
			if(iRetries > 0)
			{
				iRetries--;
				setTimeout(function() {
					pollWishlistBasketSales(iRetries);
				}, 1000);
			}
			else
			{
				$("#printLoader").hide();
			}
		}
		else
		{
			$("#printLoader").hide();

			for (var i = 0; i < oData.sales.length; i++) {
				var sSaleId = oData.sales[i];

				ticketPrint(sSaleId, 1, 0, 0);
			}
		}
	});
}

function shareWishlistLogin(oBtn)
{
	oBtn.prop("disabled", true);

	var sParams = '&id=' + sWishlistId;

	var oCall = callAjax("shareWishlistLogin", sParams, "post", "/index.cfm/wishlist/ajax/shareWishlistLogin");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			$('#popupContinue').modal('hide');

			$(".shareWishlistLoginInner").html(oData.html);

			createWishlistQrCode(oData.wishlistLoginShareUrl, document.getElementById("createLoginQrCodeResult"));
		}
		else
		{
			$('#popupContinue').modal('hide');
			inlineAlert('error', oData.errorMessage, false, oBtn, false, 10000);
		}

		oBtn.prop("disabled", false);
	});
}

function ticketPrint(sSaleId, bSale, bGiftReceipt, bAdditional, bOpenDrawer, bA4, bRetailPrice, bSellPrice)
{
	if (typeof bA4 === "undefined") bA4 = false;

	// check if fiscal solutions printer
	if (bFiscalSolutionsPrinter == '1' && !bA4) {
		if (typeof iPrintingCounter !== "undefined") iPrintingCounter++;

		// print fiscal solutions ticket
		sLocalClientIp += '/fiscalsolutions_sale?SessionId=' + sSessionId + '&SaleId=' + sSaleId;
		if(typeof bOpenDrawer !== 'undefined' && bOpenDrawer) {
			sLocalClientIp += '&opendrawer=1';
		}

		$.post(sLocalClientIp)
		.error(function(request, status, err) {
			if (typeof iPrintingCounter !== "undefined") {
				iPrintingCounter--;
				iPrintingErrors++;
			}
			else {
				showAlert('error', tErrorPrintTicket, false);
			}
		})
		.success(function() {
			clearErrors();
			if (typeof iPrintingCounter !== "undefined") iPrintingCounter--;
		});
	}
	else {
		if (typeof iPrintingCounter !== "undefined") iPrintingCounter++;

		// normal ticket
		// set parameter for bOpenDrawer
		var openDrawerParam = '&opendrawer=';
		if(typeof bOpenDrawer === 'undefined')
		{
			openDrawerParam = '';
		}
		else if(!bOpenDrawer)
		{
			openDrawerParam += '0';
		}
		else
		{
			openDrawerParam += '1';
		}

		sLocalClientIp += '/print_tickets_from_sale?sessionId=' + sSessionId + '&id=' + sSaleId + '&sale=' + bSale + '&gift=' + bGiftReceipt + '&additional=' + bAdditional + openDrawerParam;
		if(typeof bA4 != 'undefined' && bA4)
		{
			sLocalClientIp += '&A4=1';
		}
		if (typeof bRetailPrice !== "undefined" && bRetailPrice) {
			sLocalClientIp += "&retailprice=1&sellprice=0";
		}
		else if (typeof bSellPrice !== "undefined" && bSellPrice) {
			sLocalClientIp += "&retailprice=0&sellprice=1";
		}

		$.post(sLocalClientIp)
		.error(function(request, status, err)
		{
			if (typeof iPrintingCounter !== "undefined") {
				iPrintingCounter--;
				iPrintingErrors++;
			}
			else {
				showAlert('error', tErrorPrintTicket, false);
			}
		})
		.success(function()
		{
			clearErrors();
			if (typeof iPrintingCounter !== "undefined") iPrintingCounter--;
		});
	}
}

function promptReserveModal(oBtn,sSkuIds)
{
	oBtn.prop("disabled", true);

	var sParams = '&skuIds=' + sSkuIds + '&wishlistId=' + sWishlistId;
	var oCall   = callAjax("getReserveLineData", sParams, "post", "/index.cfm/wishlist/ajax/getreservelinedata");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			$(".editProductsReserveModal .modal-body").html(oData.html);
			$(".editProductsReserveModal").modal("show");

			centerPopups();
			setReserveConfirmState();

			ciResponsive.process();
		}
		else
		{
			showAlert('error', oData.errorMessage, false, 3000);
		}

		oBtn.prop("disabled", false);
	});
}

function reAddDeletedProduct(oBtn)
{
	oBtn.prop("disabled", true);

	var sSkuId = oBtn.data("skuid");
	var sQuantity = parseInt(oBtn.data("quantity"));

	var sParams = '&skuId=' + sSkuId + '&quantity=' + sQuantity + '&id=' + sWishlistId + '&refreshEditProducts=1';
	var oCall   = callAjax("addSku", sParams, "post", "/index.cfm/wishlist/ajax/addSku");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			$(('.outerContainer')).replaceWith(oData.html);
			ciResponsive.process();
		}
		else
		{
			showAlert('error', oData.errorMessage, false, 3000);
		}

		oBtn.prop("disabled", false	);
	});
}

function reserveLines(oBtn)
{
	oBtn.prop("disabled", true);

	var sSkuIds = getSelectedSkus($(".editProductsReserveModal .reserveProduct"));
	var oCall = updateLines('reserved', 1, sSkuIds);
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			$(('.outerContainer')).replaceWith(oData.html);
			ciResponsive.process();

			$(".editProductsReserveModal").modal("hide");
			$(".deleteProduct").css("display", "none");

		}
		else
		{
			showAlert('error', oData.errorMessage, false, 3000);
		}

		oBtn.prop("disabled", false);
	});
}

function searchWishlist(oFrm)
{
	var oBtn = oFrm.find('button[type="submit"]');
	oBtn.prop('disabled', true);

	var bValid = validateForm(oFrm);

	if(bValid)
	{
		var sParams = getValues(oFrm);
		var oCall = callAjax('searchWishlist', sParams, 'POST', "/index.cfm/wishlist/ajax/searchwishlist");
		oCall.success(function(oData)
		{
			if(oData.errorType === "")
			{
				$(".searchWishlist").replaceWith(oData.html);
				ciResponsive.process();
			}
			else
			{
				inlineAlert('error', oData.errorMessage, false, $(el("searchWishlistBtn")), false);
			}

			oBtn.prop('disabled', false);
		});
	}
	else
	{
		oBtn.prop('disabled', false);
	}
}

function selectAllFromAllPages(oBtn)
{
	oBtn.prop("disabled", true);

	var sSize = oBtn.data("size");

	addParam('size', sSize);

	var i = 0;
	var oInterval = setInterval(function()
	{
		if($(".editProducts .selectLine").length == sSize)
		{
			clearInterval(oInterval);

			$("#selectAll").prop("checked", true).trigger("change");

			oBtn.prop("disabled", false);
		}
		else if(i == 20)
		{
			clearInterval(oInterval);

			oBtn.prop("disabled", false);
		}

		i++;
	}, 500);
}

function selectSearchResult(oEl)
{

	var oLoader    = oEl.parents(".modal-body").find(".loaderWrapper");
	var oPopup    = oEl.parents(".modal");
	var wishlistId = oEl.data("wishlistId");

	oPopup.removeClass("enabled");
	oLoader.css("display", "flex");

	window.location = "/wishlist/" + wishlistId + "/products";
}

function setCollectMethod(sSkuId, sCollectMethodCode, bShowWarning)
{
	$(".basketSubmit").prop("disabled", true);

	var sParams = '&collectMethodCode=' + sCollectMethodCode + '&skuId=' + sSkuId + '&id=' + sWishlistId;
	var oCall = callAjax("setcollectmethod", sParams, "post", "/index.cfm/wishlist/ajax/setcollectmethod");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			var sBasketPersonalizeValues = getValues($(".basketPersonalize"));
			var sNoName  = decodeURIComponent(sBasketPersonalizeValues.split("&")[1].split("=")[1]);
			var sEmail   = decodeURIComponent(sBasketPersonalizeValues.split("&")[2].split("=")[1]);
			var sName    = decodeURIComponent(sBasketPersonalizeValues.split("&")[3].split("=")[1]);
			var sMessage = decodeURIComponent(sBasketPersonalizeValues.split("&")[4].split("=")[1]);

			(bKioskmode) ? $("#mainContainer #viewOnlyWrapper > .wishlistWrapper").replaceWith(oData.html) : $("#mainContainer > .wishlistWrapper").replaceWith(oData.html);
			ciResponsive.process();

			if(bShowWarning)
			{
				var oProduct = $(".basketProduct[data-skuid='" + sSkuId + "']");
				oProduct.find(".basketProductBuyerHandlingWarning").show()
			}

			$("#edtEmail").val(sEmail);
			$("#edtName").val(sName);
			$("#edtMessage").val(sMessage);
			$("#edtNoName").prop("checked", sNoName === "on");

			$(".basketSubmit").prop("disabled", false);
		}
		else
		{
			showAlert('error', oData.errorMessage, false, 3000);
			$(".basketSubmit").prop("disabled", true);
		}
	});
}

function setCollectProductsButtonState()
{
	var bDisable = ($(".collectProducts .selectLine:checked").length == 0);

	$(".collectProducts .collectMethodForm button[type='submit']").prop("disabled", bDisable);
}

function setReserveConfirmState()
{
	var bDisableConfirmBtn = ($(".editProductsReserveModal .selectLine:checked").length == 0);
	$(".reserveBtn").prop("disabled", bDisableConfirmBtn);
}

function showBasketCollectMethodModal(sMethod, skuId, bShowWarning)
{
	$(".basketCollectMethodModal").modal("show");
	$(".basketCollectMethodModal .collectMethod").hide();
	$(".basketCollectMethodModal .collectMethod[data-method='" + sMethod + "']").show();
	$(".basketCollectMethodModal .collectMethodSubmit").data("collectMethodCode",  sMethod);
	$(".basketCollectMethodModal .collectMethodSubmit").data("skuId", skuId);
	$(".basketCollectMethodModal .collectMethodSubmit").data("showWarning", bShowWarning);
	centerPopups();
}

// Update visibility of "Remove" buttons
function updateRemoveButtonVisibility(oBtn) {
	if (oBtn.length > 1) {
		oBtn.show(); // Show "Remove" buttons
	} else {
		oBtn.hide(); // Hide if only one baby form remains
	}
}
function submitWishlistForm(formData, oBtn, updateWishlistMode) {
	var wishlistTypeId = $("input[name='wishlistTypeId']").val();
	var wishlistTypeCode = $("input[name='wishlistTypeCode']").val();

	// Collect babies data dynamically
	let babies = [];
	$(".babyForm").each(function() {
		let babyIndex = $(this).data("index");
		let babyData = {
			name: $(`#baby_${babyIndex}_name`).val(),
			gender: $(`#baby_${babyIndex}_gender`).val(),
			hidden: ($(`#baby_${babyIndex}_hidden`).is(":checked")),
		};
		babies.push(babyData);
	});

    // Convert babies array to JSON format and encode it
    let babiesJson = encodeURIComponent(JSON.stringify(babies));

	// In update mode, strip password from formData if the user left it empty
	if (updateWishlistMode) {
		var passwordVal = $("input[name='password']").val();
		if (!passwordVal || passwordVal.trim() === "") {
			formData = formData.replace(/&?password=[^&]*/g, '');
		}

		// MB hands back the welcome message with the owner names already composed into it.
		// Sending it back unchanged makes MB compose again, so only send it when edited.
		// B2C only: the B2B payload maps a missing description to an empty onlineMessage.
		var oDescription = $("#wishlistForm input[name='isB2B']").length ? $() : $("input[name='description']");
		if (oDescription.length && oDescription.val() === oDescription[0].defaultValue) {
			formData = formData.replace(/(^|&)description=[^&]*/g, '');
		}
	}

	// Construct sParams for callAjax
	var sParams = '&Id=' + wishlistTypeId + '&code=' + wishlistTypeCode + '&' + formData + '&babiesData=' + babiesJson;

	if (updateWishlistMode) {
		// Call AJAX function
		sParams = sParams + '&wishlistid=' + sWishlistId;
		uAjax = "/index.cfm/wishlist/ajax/updateWishlist";
		var oCall = callAjax("updateWishlist", sParams, "post");
	} else {
		// Call AJAX function
		uAjax = "/index.cfm/wishlist/ajax/createWishlist";
		var oCall = callAjax("createWishlist", sParams, "post");
	}

	oCall.success(function(oData)
	{
		if(oData.errorType === "" && typeof oData.redirectUrl !== "undefined")
		{
			window.location = oData.redirectUrl;
		}
		else
		{
			showAlert("error", oData.errorMessage, oData.errorUnhandled);
		}
		oBtn.prop("disabled", false);

		/* temp log call to front-end so brent can see the request */
		console.log("Debugging:");
		console.log("Method: " + oData.debug.method);
		console.log("Request: " + oData.debug.request);
		console.log("Payload: " + oData.debug.payload);
		/* end temp log call to front-end so brent can see the request */
	});
}

function updatebasket(sParams, sSkuId, sCollectMethodCode, bShowWarning, oEl)
{
	var oCall   = callAjax("updateBasket", sParams, "post", "/index.cfm/wishlist/ajax/updatebasket");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			$('.basketCollectMethodModal').modal('hide');

			if(typeof sSkuId !== "undefined")
			{
				setCollectMethod(sSkuId, sCollectMethodCode, bShowWarning);
			}
			else
			{
				(bKioskmode) ? $("#mainContainer #viewOnlyWrapper > .wishlistWrapper").replaceWith(oData.html) : $("#mainContainer > .wishlistWrapper").replaceWith(oData.html);
				ciResponsive.process();
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, false, 3000);
		}

		if(typeof oEl !== "undefined")
		{
			oEl.prop("disabled", false);
		}
	});
}

function updateLine(oInput)
{
	var sKey   = oInput.data("key");
	var sSkuId = oInput.parents(".editProduct").data("skuid");

	if(oInput.is(":checkbox"))
	{
		var sValue = (oInput.is(":checked")) ? 1 : 0;
	}
	else
	{
		var sValue = (oInput.val() == "true") ? 1 : 0;
	}

	var sParams = '&key=' + sKey + '&value=' + sValue + '&skuId=' + sSkuId + '&id=' + sWishlistId;
	var oCall   = callAjax("updateline", sParams, "post", "/index.cfm/wishlist/ajax/updateline");
	oCall.success(function(oData)
	{
		if(oData.errorMessage !== '')
		{
			// reset checkbox to previous state
			if(oInput.is(":checkbox"))
			{
				oInput.prop("checked", !oInput.is(":checked"));
			}

			showAlert('error', oData.errorMessage, false, 3000);
		}

		/* temp log call to front-end so brent can see the request */
		console.log("Debugging:");
		console.log("Method: " + oData.debug.method);
		console.log("Request: " + oData.debug.request);
		console.log("Payload: " + oData.debug.payload);
		/* end temp log call to front-end so brent can see the request */
	});
}

function updateLines(sKey, sValue, sSkuIds)
{
	var sParams = '&key=' + sKey + '&value=' + sValue + '&skuIds=' + sSkuIds + '&id=' + sWishlistId;
	return callAjax("updatelines", sParams, "post", "/index.cfm/wishlist/ajax/updatelines");
}

function updateQuantity(oInput)
{
	var sSkuId = oInput.parents(".editProduct").data("skuid");
	var sValue = oInput.val();

	if(sValue > 0)
	{
		var sParams = '&key=quantity&value=' + sValue + '&skuId=' + sSkuId + '&id=' + sWishlistId;
		var oCall   = callAjax("updateline", sParams, "post", "/index.cfm/wishlist/ajax/updateline");
		oCall.success(function(oData)
		{
			if(oData.errorType !== '')
			{
				showAlert('error', oData.errorMessage, false, 3000);
			}
		});
	}
}

function bulkUpdateLines(sKey, bBitValue)
{
	$("#frmEditProductsBulkUpdate .btn").prop("disabled", true);

	var sSkuIds = getSelectedSkus($(".editProduct"));

	if(sSkuIds !== "")
	{
		var oCall = updateLines(sKey, bBitValue, sSkuIds);
		oCall.success(function(oData)
		{
			if(oData.errorMessage === '')
			{
				$(('.outerContainer')).replaceWith(oData.html);
				ciResponsive.process();

				$(".editProductsReserveModal").modal("hide");
			}
			else
			{
				showAlert('error', oData.errorMessage, false, 3000);
			}

			$("#frmEditProductsBulkUpdate .btn").prop("disabled", false);

			/* temp log call to front-end so brent can see the request */
			console.log("Debugging:");
			console.log("Method: " + oData.debug.method);
			console.log("Request: " + oData.debug.request);
			console.log("Payload: " + oData.debug.payload);
			/* end temp log call to front-end so brent can see the request */
		});
	}
	else
	{
		showAlert('error', 'You must select at least one product to update.', false, 3000);
		$("#frmEditProductsBulkUpdate .btn").prop("disabled", false);
	}
}

function init()
{
	$("#mainContainer #wishlistForm #contactDropdown").trigger("change");
}

function initDropzone()
{
	if($('.uploadContainer').length)
	{
		var oUploadContainer = $('.uploadContainer');
		var oInputFilename    = oUploadContainer.parents('.control-group').find('.inputFilename');
		var oImageUpload     = oUploadContainer.find('.imageUpload');
		var oUploadLoader    = oUploadContainer.find('.uploadLoader');
		var oUploadImage    = oUploadContainer.find('.uploadImage');
		var oUploadResult    = oUploadContainer.find('.uploadResult');
		// Dropzone
		if(!oImageUpload.hasClass('dz-clickable'))
		{
			oImageUpload.dropzone({
				url: "/index.cfm/content/ajax/upload/content",
				clickable: true,
				maxFilesize: 5,
				error: function(file,error,xhr)
				{
					oImageUpload.removeClass('hide');
					oUploadLoader.removeClass('hide');

					// show error message
					inlineAlert('error', error, false, $('.uploadContainer'));
				},
				success: function(file,oData)
				{
					if(oData.errorType == '')
					{
						oInputFilename.val(sStaticContentURL + tenantId + '/content/' + encodeURIComponent(oData.fileName));
						oUploadResult.find('.filename').text(oData.fileName);
						oUploadResult.toggleClass('hide');
						oImageUpload.removeClass('hide');
						oUploadImage.find("img").attr('src', sStaticContentURL + tenantId + '/content/' + encodeURIComponent(file.name));
					}
					else
					{
						oImageUpload.removeClass('hide');
						oUploadLoader.removeClass('hide');
						oImageUpload.removeClass('editUploadedImage');
						oUploadImage.addClass('hide');

						// show error message
						showAlert('error', oData.errorMessage, oData.errorUnhandled);
					}

				},
				addedfile: function(file)
				{
					oUploadResult.toggleClass('hide');
					oImageUpload.addClass('editUploadedImage');
					oUploadLoader.addClass('hide');
					oUploadImage.removeClass('hide');
				}
			});
		}

		$('#wishlistForm').on('click','.removeUpload', function()
		{
			oImageUpload.toggleClass('hide');
			oUploadImage.toggleClass('hide');
			oInputFilename.val('');
			oUploadResult.toggleClass('hide');
		});
	}
}

function validateWishlistForm(oEl)
{
	var bValidForm = validateWishlistFormFields(oEl, true);
	if(bValidForm)
	{
		bValidForm = validateForm(oEl);
	}

	return bValidForm;
}

function validateCollectMethod(oEl)
{
	oEl.prop("disabled", false);

	var bShowWarning       = oEl.find("option:selected").data("showWarning");
	var sCollectMethodCode = oEl.val();
	var sSkuId             = oEl.parents(".basketProduct").data("skuid");

	if( sCollectMethodCode === "home_delivery" && $(el("basketAddress")).val() === "false" )
	{
		showBasketCollectMethodModal(sCollectMethodCode, sSkuId, bShowWarning);
		oEl.val("");
	}
	else if( sCollectMethodCode === "click_collect" && $(el("basketShop")).val() === "false" )
	{
		if($(el("inputShop")).find("option[value!='']").length == 1)
		{
			var sParams = '&id=' + sWishlistId + "&basketId=" + sBasketId + "&collectMethodCode=" + sCollectMethodCode + "&edtShop=" + $(el("inputShop")).find("option[value!='']").val();
			updatebasket(sParams, sSkuId, sCollectMethodCode, bShowWarning);
		}
		else
		{
			showBasketCollectMethodModal(sCollectMethodCode, sSkuId, bShowWarning);
			oEl.val("");
		}
	}
	else
	{
		setCollectMethod(sSkuId, sCollectMethodCode, bShowWarning);
	}
}

function validateWishlistFormFields(oForm,editMode)
{
	var bValid = true;
	var oTerms = $(oForm).find('.termsandconditions');
	oTerms.parents('.wishlistFormTerms').siblings('.inlineAlert').remove();
	if(!$(oTerms).is(':checked') && !editMode)
	{
		var oWishlistFormTerms = oTerms.parents('.wishlistFormTerms');
		inlineAlert('error', tAgreeTC, null, oWishlistFormTerms);
		oTerms.parents('.control-group').addClass('error');

		bValid = false;
	}
	if ($("#selectedContacts").val() === "") {
		inlineAlert('error', tContactsRequired, null, "#selectedContacts", true);
		bValid = false;
	}

	return bValid;
}


// ======================== B2B GIFTLIST ========================

function initB2B() {
	// Only run on B2B pages
	if (!$('.b2bWrapper').length && !$('.b2b-date-toggle-group').length) return;

	// --- Shared: read ajax base URL from wrapper data attribute ---
	var $wrapper = $('.b2bWrapper');
	var ajaxBaseUrl = $wrapper.data('ajax-url') || '';
	var wishlistId = $wrapper.data('wishlist-id') || '';
	var participantId = $wrapper.data('participant-id') || '';

	// =============================================
	// wishlistForm.cfm — Date toggle & delivery method toggle
	// =============================================
	$(el('mainContainer')).on('change', '.b2bDateUnknownCheckbox', function() {
		var targetName = $(this).data('target');
		var $dateInput = $('#' + targetName);
		var $hiddenField = $('#' + targetName + 'Unknown');

		if ($(this).is(':checked')) {
			$dateInput.hide().removeAttr('required').val('');
			$hiddenField.val('true');
		} else {
			$dateInput.show();
			$hiddenField.val('false');
		}
	});

	$(el('mainContainer')).on('change', '.b2bDeliveryMethodRadio', function() {
		var val = $(this).val();
		if (val === 'delivery') {
			$('.b2b-delivery-address').show();
			$('.b2b-shop-picker').hide();
		} else if (val === 'click_collect') {
			$('.b2b-delivery-address').hide();
			$('.b2b-shop-picker').show();
		}
	});

	// =============================================
	// B2B delivery address edit toggle
	// =============================================
	$(el('mainContainer')).on('click', '.b2b-address-edit-btn', function() {
		$('.b2b-address-display').hide();
		$('.b2b-address-fields').show();
	});

	$(el('mainContainer')).on('click', '.b2b-address-confirm-btn', function() {
		var street = $('#delivery_street').val();
		var houseNumber = $('#delivery_houseNumber').val();
		var postalCode = $('#delivery_postalCode').val();
		var city = $('#delivery_city').val();
		var country = $('#delivery_country').val();

		$('.b2b-address-line1').text(street + ' ' + houseNumber);
		$('.b2b-address-line2').text(postalCode + ' ' + city);
		$('.b2b-address-line3').text(country.toUpperCase());

		// Update hidden fields
		$('input[name="delivery_street"].b2b-address-hidden').val(street);
		$('input[name="delivery_houseNumber"].b2b-address-hidden').val(houseNumber);
		$('input[name="delivery_postalCode"].b2b-address-hidden').val(postalCode);
		$('input[name="delivery_city"].b2b-address-hidden').val(city);
		$('input[name="delivery_country"].b2b-address-hidden').val(country);

		$('.b2b-address-fields').hide();
		$('.b2b-address-display').show();
	});

	// =============================================
	// employees.cfm — Add employee form AJAX submit
	// =============================================
	$('#b2bAddEmployeeForm').on('submit', function(e) {
		e.preventDefault();
		var $form = $(this);
		var sParams = '&' + $form.serialize();
		var submitUrl = $form.data('ajax-url');
		var successMsg = $form.data('msg-success');

		var oCall = callAjax("b2bAddEmployee", sParams, "post", submitUrl);
		oCall.success(function(oData) {
			if (oData.errorType === '') {
				$form[0].reset();
				$('.b2bEmployeeFormMessage').removeClass('hide alert-error').addClass('alert alert-success')
					.text(successMsg);
			} else {
				$('.b2bEmployeeFormMessage').removeClass('hide alert-success').addClass('alert alert-error')
					.text(oData.errorMessage);
			}
		});
	});

	// =============================================
	// selfService.cfm — employee adds own data, then goes to gift selection (ECOMMA-3897)
	// =============================================
	$('#b2bSelfServiceForm').on('submit', function(e) {
		e.preventDefault();
		var $form = $(this);
		var sParams = '&' + $form.serialize();
		var submitUrl = $form.data('ajax-url');
		var giftsUrl = $form.data('gifts-url');
		var errorMsg = $form.data('msg-error');

		var oCall = callAjax("b2bAddEmployee", sParams, "post", submitUrl);
		oCall.success(function(oData) {
			if (oData.errorType === '' && oData.employee && oData.employee.id) {
				window.location = giftsUrl + '?participantId=' + oData.employee.id;
			} else {
				$('.b2bEmployeeFormMessage').removeClass('hide alert-success').addClass('alert alert-error')
					.text(oData.errorMessage || errorMsg);
			}
		});
	});

	// =============================================
	// myEmployees.cfm — Invite all, send reminder, invite not mailed
	// =============================================
	var pendingBulkAction = null;

	$(el('mainContainer')).on('click', '.b2bInviteAll, .b2bSendReminder, .b2bInviteNotMailed', function(e) {
		e.preventDefault();
		var $btn = $(this);
		var action = $btn.hasClass('b2bInviteAll') ? 'b2bInviteAll' : ($btn.hasClass('b2bSendReminder') ? 'b2bSendReminder' : 'b2bInviteNotMailed');
		var id = $btn.data('wishlist-id');

		pendingBulkAction = { action: action, id: id };
		$('.b2bBulkActionMessage').text($btn.text().trim() + '?');
		$('.b2bBulkActionModal').modal('show');
	});

	$('.b2bBulkActionConfirmBtn').on('click', function() {
		if (!pendingBulkAction) return;
		var sParams = '&id=' + pendingBulkAction.id;
		var oCall = callAjax(pendingBulkAction.action, sParams, "post", ajaxBaseUrl + '/' + pendingBulkAction.action);
		oCall.success(function(oData) {
			$('.b2bBulkActionModal').modal('hide');
			if (oData.errorType === '') {
				showAlert('success', 'Emails sent.', false, 3000);
			} else {
				showAlert('error', oData.errorMessage, false, 3000);
			}
		});
		pendingBulkAction = null;
	});

	// =============================================
	// myEmployees.cfm — Filter checkboxes
	// =============================================
	$(el('mainContainer')).on('change', '.b2bFilterCheckbox', function() {
		var baseUrl = $('.b2bEmployeeSearch').data('url') || window.location.pathname;
		var filters = [];
		$('.b2bFilterCheckbox:checked').each(function() {
			filters.push($(this).data('filter'));
		});
		var url = baseUrl;
		if (filters.length > 0) {
			url += '?filter=' + filters.join(',');
		}
		window.location.href = url;
	});

	// =============================================
	// myEmployees.cfm — Search employees
	// =============================================
	$(el('mainContainer')).on('keypress', '.b2bEmployeeSearch', function(e) {
		if (e.which === 13) {
			e.preventDefault();
			var baseUrl = $(this).data('url') || window.location.pathname;
			var searchVal = $(this).val().trim();
			var url = baseUrl;
			if (searchVal !== '') {
				url += '?name=' + encodeURIComponent(searchVal);
			}
			window.location.href = url;
		}
	});

	// =============================================
	// giftOverview.cfm — Show selections, show status, delete selection
	// =============================================
	// employeeGifts/giftOverview — "who selected this gift" popup (paginated)
	function b2bRenderSelectionPaging(totalPages, page) {
		var $wrap = $('.b2bSelectionPopupPaging');
		$wrap.empty();
		if (totalPages <= 1) return;
		var html = '<div class="b2bPaginationLinks">';
		if (page > 1) {
			html += '<a href="#" class="paging b2bSelectionPage" data-page="' + (page - 1) + '">' + ($wrap.data('prev') || '&laquo;') + '</a>';
		}
		html += '<span class="b2bPaginationText">' + page + ' / ' + totalPages + '</span>';
		if (page < totalPages) {
			html += '<a href="#" class="paging b2bSelectionPage" data-page="' + (page + 1) + '">' + ($wrap.data('next') || '&raquo;') + '</a>';
		}
		html += '</div>';
		$wrap.html(html);
	}

	function b2bLoadSelections(productId, productName, productImg, page, doShow) {
		var sParams = '&id=' + wishlistId + '&productId=' + productId + '&page=' + page;
		var oCall = callAjax("b2bGetEmployeeSelections", sParams, "get", ajaxBaseUrl + '/b2bGetEmployeeSelections');
		oCall.success(function(oData) {
			var sel = oData.selections || {};
			var items = sel.items || [];
			var $modal = $('.b2bSelectionPopupModal');
			// remember the current item so the paging links can re-fetch the same one
			$modal.data('product-id', productId).data('product-name', productName).data('product-img', productImg);

			$('.b2bSelectionPopupProductName').text(productName);
			if (productImg) {
				$('.b2bSelectionPopupProductImg').html('<img src="' + productImg + '" width="60" height="60" alt="">');
			}

			var $tbody = $('.b2bSelectionPopupTable tbody');
			$tbody.empty();
			$.each(items, function(i, s) {
				var name = ((s.firstName || '') + ' ' + (s.lastName || '')).trim();
				$tbody.append(
					'<tr data-employee-id="' + (s.id || '') + '">' +
					'<td>' + name + '</td>' +
					'<td>' + (s.department || '') + '</td>' +
					'<td>' + (s.employeeNumber || '') + '</td>' +
					'<td><a href="#" class="b2bDeleteSelection" data-product-id="' + productId + '" data-employee-id="' + (s.id || '') + '"><i class="fa fa-trash"></i></a></td>' +
					'</tr>'
				);
			});

			b2bRenderSelectionPaging(sel.totalPages || 1, page);

			if (doShow) { $modal.modal('show'); }
		});
	}

	$(el('mainContainer')).on('click', '.b2bShowSelections', function() {
		var $item = $(this).closest('.b2bGiftListItem');
		var productId = $(this).data('product-id');
		var productName = $item.find('.b2bGiftListName').text().trim();
		var productImg = $item.find('.b2bGiftListImage img').attr('ci-src') || $item.find('.b2bGiftListImage img').attr('src') || '';
		b2bLoadSelections(productId, productName, productImg, 1, true);
	});

	// Paginate the selections popup (keeps the modal open, re-fetches the current item)
	$(el('mainContainer')).on('click', '.b2bSelectionPage', function(e) {
		e.preventDefault();
		var $modal = $('.b2bSelectionPopupModal');
		var p = parseInt($(this).data('page'), 10);
		b2bLoadSelections($modal.data('product-id'), $modal.data('product-name'), $modal.data('product-img'), p > 0 ? p : 1, false);
	});

	$(el('mainContainer')).on('click', '.b2bShowStatus', function() {
		var productId = $(this).data('product-id');
		var $item = $(this).closest('.b2bGiftListItem');
		var productName = $item.find('.b2bGiftListName').text().trim();
		var $img = $item.find('.b2bGiftListImage img');
		var productImg = $img.attr('ci-src') || $img.attr('src') || '';

		var sParams = '&id=' + wishlistId + '&productId=' + productId;
		var oCall = callAjax("b2bGetFulfilmentStatus", sParams, "get", ajaxBaseUrl + '/b2bGetFulfilmentStatus');
		oCall.success(function(oData) {
			var $body = $('.b2bStatusPopupBody');
			$body.empty();
			if (oData.statusBreakdown && oData.statusBreakdown.length) {
				$.each(oData.statusBreakdown, function(i, item) {
					var imgHtml = productImg ? '<div class="b2bStatusRowImage"><img src="' + productImg + '" alt=""></div>' : '';
					var noteHtml = item.note ? '<span class="b2bStatusRowNote"><i class="fal fa-info-circle"></i> ' + item.note + '</span>' : '';
					$body.append(
						'<div class="b2bStatusRow b2bStatusRow--' + (item.status || 'normal') + '">' +
							imgHtml +
							'<div class="b2bStatusRowInfo">' +
								'<span class="b2bStatusRowName">' + productName + '</span>' +
								noteHtml +
							'</div>' +
							'<div class="b2bStatusRowQty">' + (item.statusText || '') + '</div>' +
						'</div>'
					);
				});
			}
			$('.b2bStatusPopupModal').modal('show');
		});
	});

	$(el('mainContainer')).on('click', '.b2bDeleteSelection', function(e) {
		e.preventDefault();
		var productId = $(this).data('product-id');
		var employeeId = $(this).data('employee-id');
		var $row = $(this).closest('tr');
		var sParams = '&id=' + wishlistId + '&productId=' + productId + '&employeeId=' + employeeId;
		var oCall = callAjax("b2bDeleteProductSelection", sParams, "delete", ajaxBaseUrl + '/b2bDeleteProductSelection');
		oCall.success(function(oData) {
			if (oData.errorType === '') {
				$row.remove();
			} else {
				showAlert('error', oData.errorMessage, false, 3000);
			}
		});
	});

	// =============================================
	// settings.cfm — Settings form AJAX submit
	// =============================================
	$('#b2bSettingsForm').on('submit', function(e) {
		e.preventDefault();
		var sParams = '&' + $(this).serialize();
		var submitUrl = $(this).data('ajax-url');
		var successMsg = $(this).data('msg-success');

		var oCall = callAjax("b2bUpdateSettings", sParams, "put", submitUrl);
		oCall.success(function(oData) {
			if (oData.errorType === '') {
				$('.b2bSettingsMessage').removeClass('hide alert-error').addClass('alert alert-success')
					.text(successMsg);
			} else {
				$('.b2bSettingsMessage').removeClass('hide alert-success').addClass('alert alert-error')
					.text(oData.errorMessage);
			}
		});
	});

	// =============================================
	// employees.cfm — Generate & copy the self-service link (ECOMMA-3897)
	// =============================================
	$(el('mainContainer')).on('click', '.b2bGenerateSelfServiceLink', function(e) {
		e.preventDefault();
		var sUrl = $(this).data('url');
		$('.b2bSelfServiceUrlWrapper').removeClass('hide');

		function showCopied() {
			$('.b2bSelfServiceCopied').removeClass('hide');
		}

		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(sUrl).then(showCopied, function() {});
		} else {
			var $tmp = $('<textarea>').val(sUrl).css({ position: 'fixed', left: '-9999px' }).appendTo('body');
			$tmp[0].select();
			try { document.execCommand('copy'); showCopied(); } catch (err) {}
			$tmp.remove();
		}
	});

	// =============================================
	// employeeGifts.cfm — Choose gift (euro and coin paths)
	// =============================================
	$(el('mainContainer')).on('click', '.b2bChooseGift', function() {
		var productId = $(this).data('product-id');
		var $listing = $('.b2bProductListing');
		var isCoinBased = $listing.data('is-coin-based') === true;
		var coinBasketUrl = $listing.data('coin-basket-url');
		var selectionBasketUrl = $listing.data('selection-basket-url');

		if (isCoinBased) {
			var sParams = '&productId=' + productId;
			var oCall = callAjax("b2bAddToCoinBasket", sParams, "post", ajaxBaseUrl + '/b2bAddToCoinBasket');
			oCall.success(function(oData) {
				if (oData.errorType === '') {
					window.location.href = coinBasketUrl;
				}
			});
		} else {
			var $popover = $('.b2bConfirmSelectionPopover');

			// If already have a selection in the popover, show conflict popup
			if (!$popover.hasClass('hide')) {
				$('.b2bConflictPopupModal').modal('show');
				return;
			}

			// Store selected product and show confirm popover
			var $card = $(this).closest('.b2bGiftProduct');
			var productName = $card.find('.b2bGiftProductName').text().trim();
			var productImg = $card.find('.b2bGiftProductImage img').attr('src') || '';

			$popover.data('selected-product-id', productId);
			$popover.find('.b2bConfirmProductName').text(productName);
			if (productImg) {
				$popover.find('.b2bConfirmProductImg').html('<img src="' + productImg + '" width="60" height="60" alt="">');
			}
			$popover.removeClass('hide');
		}
	});

	// =============================================
	// employeeGifts.cfm — Filters: MB tags + ES product facets (AJAX refresh of the grid)
	// =============================================

	function b2bBuildFacetParam(oGroups) {
		return Object.keys(oGroups).map(function(sName) {
			return sName + '|' + oGroups[sName].join(',');
		}).join(';');
	}

	function b2bApplyGiftFilters(iPage) {
		// change/clear/slider callbacks pass an event or nothing → default to page 1; paging links pass a number
		var page = (typeof iPage === 'number' && iPage > 0) ? iPage : 1;
		var $listWrapper = $('.b2bEmployeeView');
		var listId = $listWrapper.data('wishlist-id');
		var pId = $listWrapper.data('participant-id');

		// MultiBazar tag filters
		var tagIds = [];
		$('.b2bTagFilter:checked').each(function() {
			tagIds.push($(this).val());
		});

		// ES facets: split into filters vs features exactly like the main product list (product.list.js).
		// Feature-type facets (gender, brand, grouplevel, ...) must go in `features`, not `filters`,
		// otherwise the search service ignores them and returns no results.
		var filterFields = ['size', 'colours', 'price_current', 'price_used', 'instock'];
		var oFilters = {}, oFeatures = {};
		$('.b2bEmployeeFilters .iFacet:checked').each(function() {
			var sName = $(this).data('filter');
			var sValue = decodeURIComponent(String($(this).data('value')));
			var oTarget = (filterFields.indexOf(String(sName).toLowerCase()) > -1) ? oFilters : oFeatures;
			(oTarget[sName] = oTarget[sName] || []).push(sValue);
		});

		// ES price facet: a hidden .priceDataValue input carries "min-max" (always a filter)
		$('.b2bEmployeeFilters .priceDataValue').each(function() {
			var sValue = $(this).attr('data-value');
			if (sValue) {
				var sName = $(this).data('filter');
				(oFilters[sName] = oFilters[sName] || []).push(sValue);
			}
		});

		var sFilters = b2bBuildFacetParam(oFilters);
		var sFeatures = b2bBuildFacetParam(oFeatures);

		// Show the "clear filters" control only when at least one filter is active
		var bActive = tagIds.length > 0 || sFilters !== '' || sFeatures !== '';
		$('.b2bClearFilters').toggleClass('hide', !bActive);

		var sParams = '&id=' + listId
			+ '&participantId=' + pId
			+ '&tagIds=' + tagIds.join(',')
			+ '&filters=' + encodeURIComponent(sFilters)
			+ '&features=' + encodeURIComponent(sFeatures)
			+ '&page=' + page;

		var oCall = callAjax("b2bFilterGifts", sParams, "get", ajaxBaseUrl + '/b2bFilterGifts');
		oCall.success(function(oData) {
			if (oData.errorType === '' && typeof oData.html !== 'undefined') {
				$('.b2bProductListing').html(oData.html);
			} else {
				showAlert('error', oData.errorMessage, false, 5000);
			}
		});
	}

	// Compact price slider (esFacetPrice) — reuses jQuery UI, applies on slide stop
	function b2bInitPriceSlider() {
		if (typeof $.fn.slider !== 'function') return;
		$('.b2bEmployeeFilters .pro-range-slider').each(function() {
			var $wrap = $(this);
			var priceMin = Math.floor(parseFloat($wrap.find('.edtPriceMin').val()));
			var priceMax = Math.ceil(parseFloat($wrap.find('.edtPriceMax').val()));
			if (isNaN(priceMin) || isNaN(priceMax) || (priceMax - priceMin) <= 1) {
				$wrap.hide();
				return;
			}
			var currency = $wrap.find('.edtCurrency').val() || '';
			$wrap.find('#slider-range').slider({
				range: true, min: priceMin, max: priceMax, step: 1,
				values: [priceMin, priceMax],
				create: function() {
					$wrap.find('#amount').val(currency + priceMin + ' - ' + currency + priceMax);
				},
				slide: function(event, ui) {
					$wrap.find('#amount').val(currency + ui.values[0] + ' - ' + currency + ui.values[1]);
				},
				stop: function(event, ui) {
					var sVal = (ui.values[0] === priceMin && ui.values[1] === priceMax) ? '' : ui.values[0] + '-' + ui.values[1];
					$wrap.find('.priceDataValue').attr('data-value', sVal);
					b2bApplyGiftFilters();
				}
			});
		});
	}

	$(el('mainContainer')).on('change', '.b2bTagFilter, .b2bEmployeeFilters .iFacet', b2bApplyGiftFilters);

	// Paginate the gift grid (AJAX; keeps the active tag/facet selection)
	$(el('mainContainer')).on('click', '.b2bGiftPage', function(e) {
		e.preventDefault();
		var p = parseInt($(this).data('page'), 10);
		b2bApplyGiftFilters(p > 0 ? p : 1);
	});

	// Clear all filters (tags + facets) and show every gift again
	$(el('mainContainer')).on('click', '.b2bClearFilters', function(e) {
		e.preventDefault();
		$('.b2bTagFilter, .b2bEmployeeFilters .iFacet').prop('checked', false);
		$('.b2bEmployeeFilters .priceDataValue').attr('data-value', '');
		$('.b2bEmployeeFilters #slider-range').each(function() {
			if ($(this).is('.ui-slider')) {
				$(this).slider('values', [$(this).slider('option', 'min'), $(this).slider('option', 'max')]);
			}
		});
		b2bApplyGiftFilters();
	});

	// Facet "show more / less" (esFacet viewlets, >4 options)
	$(el('mainContainer')).on('click', '.b2bEmployeeFilters .toggleMoreFacets', function(e) {
		e.preventDefault();
		$(this).hide().parents('ul').find('.toggleHide').show();
		$(this).parents('ul').find('.toggleLessFacets').show();
	});
	$(el('mainContainer')).on('click', '.b2bEmployeeFilters .toggleLessFacets', function(e) {
		e.preventDefault();
		$(this).hide().parents('ul').find('.toggleHide').hide();
		$(this).parents('ul').find('.toggleMoreFacets').show();
	});

	// Collapse / expand a facet group
	$(el('mainContainer')).on('click', '.b2bEmployeeFilters .titleHeader', function() {
		$(this).toggleClass('closed').nextAll().slideToggle(150);
	});

	b2bInitPriceSlider();

	// =============================================
	// employeeGifts.cfm — Confirm selection popup
	// =============================================
	$('.b2bConfirmPopoverClose').on('click', function(e) {
		e.preventDefault();
		$('.b2bConfirmSelectionPopover').addClass('hide');
	});

	$('.b2bConfirmChoiceBtn').on('click', function() {
		var $popover = $('.b2bConfirmSelectionPopover');
		var productId = $popover.data('selected-product-id');
		var sParams = '&productId=' + productId + '&id=' + wishlistId + '&participantId=' + participantId;
		var oCall = callAjax("b2bMakeChoice", sParams, "post", ajaxBaseUrl + '/b2bMakeChoice');
		oCall.success(function(oData) {
			if (oData.errorType === '') {
				$popover.addClass('hide');
				var selName = encodeURIComponent($popover.find('.b2bConfirmProductName').text());
				var selImg = encodeURIComponent($popover.find('.b2bConfirmProductImg img').attr('src') || '');
				window.location.href = '/wishlist/b2b/' + wishlistId + '/success?participantId=' + participantId + '&productName=' + selName + '&productImage=' + selImg;
			} else {
				$popover.addClass('hide');
				showAlert('error', oData.errorMessage, false, 3000);
			}
		});
	});

	// =============================================
	// coinBasket.cfm — Remove from coin basket
	// =============================================
	$(el('mainContainer')).on('click', '.b2bRemoveFromCoinBasket', function(e) {
		e.preventDefault();
		var productId = $(this).data('product-id');
		var sParams = '&productId=' + productId;
		var oCall = callAjax("b2bRemoveFromCoinBasket", sParams, "delete", ajaxBaseUrl + '/b2bRemoveFromCoinBasket');
		oCall.success(function(oData) {
			if (oData.errorType === '') {
				location.reload();
			}
		});
	});

	// =============================================
	// selectionBasket.cfm — Remove selection
	// =============================================
	$(el('mainContainer')).on('click', '.b2bRemoveSelection', function() {
		var $btn = $(this);
		var redirectUrl = $btn.data('redirect-url');
		var sParams = '&id=' + wishlistId;
		var oCall = callAjax("b2bDeleteChoice", sParams, "delete", ajaxBaseUrl + '/b2bDeleteChoice');
		oCall.success(function(oData) {
			if (oData.errorType === '') {
				window.location.href = redirectUrl;
			}
		});
	});

	// =============================================
	// confirm.cfm — Confirm selection form submit
	// =============================================
	$('#b2bConfirmForm').on('submit', function(e) {
		e.preventDefault();
		var comment = $('#b2bComment').val();
		var submitUrl = $(this).data('ajax-url');
		var successUrl = $(this).data('success-url');

		var sParams = '&id=' + wishlistId + '&comment=' + encodeURIComponent(comment);
		var oCall = callAjax("b2bConfirmSelection", sParams, "post", submitUrl);
		oCall.success(function(oData) {
			if (oData.errorType === '') {
				window.location.href = successUrl;
			} else {
				alert(oData.errorMessage);
			}
		});
	});

	// =============================================
	// employeePopup.cfm — Delete employee, edit employee, delete choice, send email
	// =============================================
	var currentEmployeeId = '';
	var deleteConfirmTpl = $('.b2bDeleteEmployeeModal').data('confirm-tpl') || '';

	$(el('mainContainer')).on('click', '.b2bDeleteEmployee', function(e) {
		e.preventDefault();
		currentEmployeeId = $(this).data('employee-id');
		var employeeName = $(this).data('employee-name');
		$('.b2bDeleteConfirmMessage').text(deleteConfirmTpl.replace('{name}', employeeName));
		$('.b2bDeleteEmployeeModal').modal('show');
	});

	$('.b2bConfirmDeleteEmployee').on('click', function() {
		var sParams = '&id=' + wishlistId + '&employeeId=' + currentEmployeeId;
		var oCall = callAjax("b2bDeleteEmployee", sParams, "delete", ajaxBaseUrl + '/b2bDeleteEmployee');
		oCall.success(function(oData) {
			$('.b2bDeleteEmployeeModal').modal('hide');
			if (oData.errorType === '') {
				$('tr[data-employee-id="' + currentEmployeeId + '"]').remove();
			} else {
				showAlert('error', oData.errorMessage, false, 5000);
			}
		});
	});

	$(el('mainContainer')).on('click', '.b2bEditEmployee', function(e) {
		e.preventDefault();
		currentEmployeeId = $(this).data('employee-id');
		var choiceMade = $(this).data('choice-made');
		var employeeName = $(this).data('employee-name');
		var childName = $(this).data('child-name');
		var selectionName = $(this).data('selection-name') || '';
		var selectionImg = $(this).data('selection-img') || '';

		$('.b2bEditWithChoice, .b2bEditWithoutChoice').addClass('hide');
		$('.b2bEditEmployeeModalTitle').text(employeeName);
		$('.b2bEditChildName').text(childName || '');

		if (choiceMade) {
			$('.b2bChosenGiftName').text(selectionName);
			if (selectionImg) {
				$('.b2bChosenGiftImg').html('<img src="' + selectionImg + '" width="80" height="80" alt="">');
			} else {
				$('.b2bChosenGiftImg').html('');
			}
			$('.b2bEditWithChoice').removeClass('hide');
		} else {
			$('.b2bEditWithoutChoice').removeClass('hide');
		}
		$('.b2bEditEmployeeModal').modal('show');
	});

	$('.b2bDeleteChoiceBtn').on('click', function() {
		var sParams = '&id=' + wishlistId + '&employeeId=' + currentEmployeeId;
		var oCall = callAjax("b2bDeleteChoice", sParams, "delete", ajaxBaseUrl + '/b2bDeleteChoice');
		oCall.success(function(oData) {
			if (oData.errorType === '') {
				$('.b2bEditEmployeeModal').modal('hide');
				location.reload();
			} else {
				showAlert('error', oData.errorMessage, false, 5000);
			}
		});
	});

	$('.b2bSendEmailBtn').on('click', function() {
		var sParams = '&id=' + wishlistId + '&employeeId=' + currentEmployeeId;
		var oCall = callAjax("b2bSendEmployeeInvite", sParams, "post", ajaxBaseUrl + '/b2bSendEmployeeInvite');
		oCall.success(function(oData) {
			$('.b2bEditEmployeeModal').modal('hide');
			if (oData.errorType === '') {
				location.reload();
			} else {
				showAlert('error', oData.errorMessage, false, 5000);
			}
		});
	});

	$('.b2bMakeChoiceBtn').on('click', function() {
		$('.b2bEditEmployeeModal').modal('hide');
		window.location.href = '/wishlist/b2b/' + wishlistId + '/gifts?participantId=' + currentEmployeeId;
	});
}

// Call initB2B on DOM ready
$(function() {
	initB2B();
});
